export enum SessionStatus {
  RUNNING = 'RUNNING',
  RESUMABLE = 'RESUMABLE',
  VOID = 'VOID',
  CORRUPTED = 'CORRUPTED',
}

export enum HostStatus {
  ALIVE = 'ALIVE',
  DORMANT = 'DORMANT',
  DEAD = 'DEAD',
}

export interface SessionStatusChangedPayload {
  readonly userExternalId: string
  readonly claudeSessionId: string
  readonly status: SessionStatus
  readonly previousStatus: SessionStatus | null
}

export interface HostStatusChangedPayload {
  readonly userExternalId: string
  readonly hostId: string
  readonly hostName: string
  readonly status: HostStatus
  readonly previousStatus: HostStatus | null
}
